import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import SessionInfo from "model/api/SessionInfo.model";

export interface SessionState {
  sessions: SessionInfo[];
}

const initialState: SessionState = {
  sessions: [],
};

const demoSessionSlice = createSlice({
  name: "demoSession",
  initialState,
  reducers: {
    setDemoSessions: (state: SessionState, action: PayloadAction<SessionInfo[]>) => {
      state.sessions = action.payload;
    },
  },
});

export const { setDemoSessions } = demoSessionSlice.actions;

export default demoSessionSlice.reducer;
